export function parseErrors(errorResponse) {
  const errorMessages = [];

  Object.entries(errorResponse).forEach(([field, errors]) => {
    // Assuming errors for each field is an array
    errors.forEach(error => {
      errorMessages.push(`${field.replace('_', ' ')}: ${error}`);
    });
  });

  return errorMessages;
}

export function aggregateErrors(errors) {
  const errorMessages = [];

  if (typeof errors === 'string' && errors.length <= 64) {
    return errors;
  }
  if (typeof errors === 'string' && errors.length > 64) {
    return 'Unknown error';
  }

  Object.values(errors).forEach(value => {
    if (Array.isArray(value)) {
      value.forEach(error => {
        errorMessages.push(error);
      });
    } else {
      errorMessages.push(value);
    }
  });

  if (errorMessages.length === 0) {
    return 'Unknown error';
  }

  return errorMessages.join(', ');
}
